import React from "react";


// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface PaletaColoresSegmentadaSVGProps extends React.HTMLAttributes<any> {
    strokeWidth?: number,
    strokeColor?: string
}

export const PaletaColoresSegmentada: React.FC<PaletaColoresSegmentadaSVGProps> = ({strokeWidth= 1, strokeColor="white", className, style}) => (
    <svg className={className} style={style} viewBox="-100 -100 200 200">
        {/* Segmentos radiales con anillos concéntricos con márgenes */}
        {/* Centro en (0,0) */}
        <g>
            {/* Número de segmentos: 8 */}
            {/* Anillos: Externo (100-75), Medio (75-50), Interno (50-25) */}

            {/* Segmento 1 */}
            {/* Anillo externo */}
            <path
                d="M100,0 A100,100 0 0,1 70.7107,70.7107 L53.0330,53.0330 A75,75 0 0,0 75,0 Z"
                fill="hsl(0, 100%, 50%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo medio */}
            <path
                d="M75,0 A75,75 0 0,1 53.0330,53.0330 L35.3553,35.3553 A50,50 0 0,0 50,0 Z"
                fill="hsl(0, 100%, 60%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo interno */}
            <path
                d="M50,0 A50,50 0 0,1 35.3553,35.3553 L17.6777,17.6777 A25,25 0 0,0 25,0 Z"
                fill="hsl(0, 100%, 70%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />

            {/* Segmento 2 */}
            {/* Anillo externo */}
            <path
                d="M70.7107,70.7107 A100,100 0 0,1 0,100 L0,75 A75,75 0 0,0 53.0330,53.0330 Z"
                fill="hsl(45, 100%, 50%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo medio */}
            <path
                d="M53.0330,53.0330 A75,75 0 0,1 0,75 L0,50 A50,50 0 0,0 35.3553,35.3553 Z"
                fill="hsl(45, 100%, 60%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo interno */}
            <path
                d="M35.3553,35.3553 A50,50 0 0,1 0,50 L0,25 A25,25 0 0,0 17.6777,17.6777 Z"
                fill="hsl(45, 100%, 70%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />

            {/* Segmento 3 */}
            {/* Anillo externo */}
            <path
                d="M0,100 A100,100 0 0,1 -70.7107,70.7107 L-53.0330,53.0330 A75,75 0 0,0 0,75 Z"
                fill="hsl(90, 100%, 50%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo medio */}
            <path
                d="M0,75 A75,75 0 0,1 -53.0330,53.0330 L-35.3553,35.3553 A50,50 0 0,0 0,50 Z"
                fill="hsl(90, 100%, 60%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo interno */}
            <path
                d="M0,50 A50,50 0 0,1 -35.3553,35.3553 L-17.6777,17.6777 A25,25 0 0,0 0,25 Z"
                fill="hsl(90, 100%, 70%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />

            {/* Segmento 4 */}
            {/* Anillo externo */}
            <path
                d="M-70.7107,70.7107 A100,100 0 0,1 -100,0 L-75,0 A75,75 0 0,0 -53.0330,53.0330 Z"
                fill="hsl(135, 100%, 50%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo medio */}
            <path
                d="M-53.0330,53.0330 A75,75 0 0,1 -75,0 L-50,0 A50,50 0 0,0 -35.3553,35.3553 Z"
                fill="hsl(135, 100%, 60%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo interno */}
            <path
                d="M-35.3553,35.3553 A50,50 0 0,1 -50,0 L-25,0 A25,25 0 0,0 -17.6777,17.6777 Z"
                fill="hsl(135, 100%, 70%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />

            {/* Segmento 5 */}
            {/* Anillo externo */}
            <path
                d="M-100,0 A100,100 0 0,1 -70.7107,-70.7107 L-53.0330,-53.0330 A75,75 0 0,0 -75,0 Z"
                fill="hsl(180, 100%, 50%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo medio */}
            <path
                d="M-75,0 A75,75 0 0,1 -53.0330,-53.0330 L-35.3553,-35.3553 A50,50 0 0,0 -50,0 Z"
                fill="hsl(180, 100%, 60%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo interno */}
            <path
                d="M-50,0 A50,50 0 0,1 -35.3553,-35.3553 L-17.6777,-17.6777 A25,25 0 0,0 -25,0 Z"
                fill="hsl(180, 100%, 70%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />

            {/* Segmento 6 */}
            {/* Anillo externo */}
            <path
                d="M-70.7107,-70.7107 A100,100 0 0,1 0,-100 L0,-75 A75,75 0 0,0 -53.0330,-53.0330 Z"
                fill="hsl(225, 100%, 50%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo medio */}
            <path
                d="M-53.0330,-53.0330 A75,75 0 0,1 0,-75 L0,-50 A50,50 0 0,0 -35.3553,-35.3553 Z"
                fill="hsl(225, 100%, 60%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo interno */}
            <path
                d="M-35.3553,-35.3553 A50,50 0 0,1 0,-50 L0,-25 A25,25 0 0,0 -17.6777,-17.6777 Z"
                fill="hsl(225, 100%, 70%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />

            {/* Segmento 7 */}
            {/* Anillo externo */}
            <path
                d="M0,-100 A100,100 0 0,1 70.7107,-70.7107 L53.0330,-53.0330 A75,75 0 0,0 0,-75 Z"
                fill="hsl(270, 100%, 50%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo medio */}
            <path
                d="M0,-75 A75,75 0 0,1 53.0330,-53.0330 L35.3553,-35.3553 A50,50 0 0,0 0,-50 Z"
                fill="hsl(270, 100%, 60%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo interno */}
            <path
                d="M0,-50 A50,50 0 0,1 35.3553,-35.3553 L17.6777,-17.6777 A25,25 0 0,0 0,-25 Z"
                fill="hsl(270, 100%, 70%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />

            {/* Segmento 8 */}
            {/* Anillo externo */}
            <path
                d="M70.7107,-70.7107 A100,100 0 0,1 100,0 L75,0 A75,75 0 0,0 53.0330,-53.0330 Z"
                fill="hsl(315, 100%, 50%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo medio */}
            <path
                d="M53.0330,-53.0330 A75,75 0 0,1 75,0 L50,0 A50,50 0 0,0 35.3553,-35.3553 Z"
                fill="hsl(315, 100%, 60%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Anillo interno */}
            <path
                d="M35.3553,-35.3553 A50,50 0 0,1 50,0 L25,0 A25,25 0 0,0 17.6777,-17.6777 Z"
                fill="hsl(315, 100%, 70%)"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
        </g>
    </svg>
);